/* eslint-disable camelcase */
const AgilityFixed = ({ databoxes: { percent_fixed } }) =>
  `${percent_fixed}% of users were in occupation more than 80%
   of the peak times recorded and could be considered “fixed” workers.`;

export default AgilityFixed;
